import { useContext, useEffect } from 'react';
import { GridViewContext } from '../context/Grid.view.context';

export const useSetCurrentWorkspace = () => {
  const {
    setCurrentWorkspaceUuid,
    workspaces
  } = useContext(GridViewContext);

  useEffect(() => {
    const currentWorkspace = workspaces?.find((w) => w.isActive);
    if (currentWorkspace) {
      setCurrentWorkspaceUuid(currentWorkspace.uuid);
    }
  }, []);
};
